<template>
  <div class="activities">
    <div class="title">
      <div></div>
      角色管理
    </div>
    <div class="query">
      <div class="query-box">
        <span>输入</span>
        <el-input v-model="name" placeholder="请输入角色名称"></el-input>
      </div>
      <!-- <div class="query-box">
        <span>日期</span>
        <el-date-picker
          v-model="activityTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
           @change='querys'
        >
        </el-date-picker>
      </div> -->
      <el-button type="primary" @click="inquire">查询</el-button>
    </div>
    <div class="top-btn">
      <el-button icon="el-icon-plus" type="primary" @click="addDialog=true">新增</el-button>
      <el-button icon="el-icon-refresh" type="primary" @click="refresh">刷新</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="describes" label="角色名称">
        </el-table-column>
      
        <!-- <el-table-column align="center" prop="createTime" label="创建时间">
        </el-table-column> -->

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete( scope.row.id)"
              >删除</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit( scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="handleSet(scope.row.id)"
              >设置授权</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  <!-- 新增 -->
  <el-dialog
  title="创建角色"
  :visible.sync="addDialog"
  width="30%"
  center
 >
    <el-form :model="form">
    <el-form-item label="角色名称" label-width="80px" >
      <el-input v-model="form.name" autocomplete="off" ></el-input>
    </el-form-item>
    <!-- <el-form-item label="备注" label-width="80px" > 
           <el-input type="textarea" v-model="form.code" ></el-input>
    </el-form-item> -->
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="addDialog = false">取 消</el-button>
    <el-button type="primary" @click="addRole">确 定</el-button>
  </span>
</el-dialog>
  <!-- 编辑 -->
  <el-dialog
  title="编辑角色"
  :visible.sync="editDialog"
  width="30%"
  center
 >
    <el-form :model="eaidForm">
    <el-form-item label="角色名称" label-width="80px" >
      <el-input v-model="eaidForm.describes" autocomplete="off" ></el-input>
    </el-form-item>
    <!-- <el-form-item label="备注" label-width="80px" > 
           <el-input type="textarea" v-model="form.code" ></el-input>
    </el-form-item> -->
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="editDialog = false">取 消</el-button>
    <el-button type="primary" @click="editRole">确 定</el-button>
  </span>
</el-dialog>
  <!-- 设置权限 -->
  <el-dialog
  title="分配权限"
  :visible.sync="jurisdictions"
  width="30%"
  center
  :before-close='shut'
 >
    <el-checkbox-group v-model="jurisdiction">
    <el-checkbox border style="margin:0 10px 20px" :label=item.id v-for="(item,i) in jurisdictionList" :key='i'>{{item.describes}}</el-checkbox>
  </el-checkbox-group>
  <span slot="footer" class="dialog-footer">
    <el-button @click="cancel">取 消</el-button>
    <el-button type="primary" @click="jurisdictionRole">确 定</el-button>
  </span>
</el-dialog>


  </div>
</template>

<script>
import moment from "moment";
import reg from "@/utils/reg.js";
import {addRole,rolePageList,delRole,updateRole,grantList,grantListByRoleId,assignPer} from "@/api/api"
export default {
  data() {
    return {
      editDialog:false,
      jurisdictions:false,
      name: "",
        startTime:'',
      endTime:'',
      activityTime: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
        // 新增
        addDialog:false,
        form:{
        
          name:''
        },
        eaidForm:{
          describes:''
        },
        jurisdiction:[],
        jurisdictionList:[],
        roleId:'',

    };
  },
  created () {
    this.getList();
  },
  methods: {
      querys(){
       if(this.activityTime==null){
         this.startTime='',
          this.endTime=''
       }
    },
   //新增
    addRole:reg._debounce(async function(){
      if(!this.form.name){
         this.$message.error('角色名称不能为空')
         return false
      }
         let res =await addRole({
        // code:this.form.code,
        name:this.form.name,
      })
      if(res.code==200){
         this.$message({
          type: "success",
          message: "添加成功",
        });
        this.form.name=''
        // this.form.code=''
         this.getList();
         this.addDialog=false
      }  
   },500),
    // 获取列表
   async getList(){
        let res =await rolePageList({
           name:this.name,
             startTime:this.startTime,
          endTime:this.endTime,
          pageSize:this.pageSize,
          pageNum:this.currentPage
        })
        console.log(res)
       let {data}=res
     //  边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
        this.tableData=data.itemList
        this.total=data.totalSize
    },
      // 查询
    inquire(){
     if(this.activityTime){
       this.startTime=  moment(this.activityTime[0]).format("YYYY-MM-DD HH:mm:ss"),
       this.endTime=  moment(this.activityTime[1]).format("YYYY-MM-DD HH:mm:ss")
     }  
        this.getList();
    },
       // 刷新
    refresh(){
      this.name=''
      this.startTime=''
      this.endTime=''
      this.activityTime=''
        this.getList();
    },

    //   删除
    handleDelete(id) {
         this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let { code } = await delRole({ id });
          if (code === 200) {
              this.$message({
              type: "success",
              message: "删除成功",
        });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //编辑
    handleEdit(row) {
      this.eaidForm={...row}
      this.editDialog=true
    },
    // 编辑确定
  async  editRole(){
     let res =await updateRole(this.eaidForm)
       if(res.code==200){
         this.editDialog=false
            this.$message({
              type: "success",
              message: "修改成功",
              })
              this.getList()
       }else{
          $message.error(res.msg)
       }
    },

    // 设置权限
   async handleSet(id) {
     this.roleId=id
     let res =await grantList()
     console.log('xx',res)
      this.jurisdictionList=res.data
     let ress=await grantListByRoleId({roleId:id})
     console.log(ress)
     ress.data.forEach(item=>{
       this.jurisdiction.push(item.id)

     })
     console.log( this.jurisdiction)
    
     this.jurisdictions=true


    },
    // 关闭权限框
    shut(){
      // console.log(11)
      this.jurisdiction=[]
      this.jurisdictions=false
    },
    // 取消
    cancel(){
      this.jurisdiction=[]
     this.jurisdictions=false
    },
    // 确定 分配权限
  async jurisdictionRole(){
      let res =await assignPer({
         roleId:this.roleId,
         grantIds:this.jurisdiction
      })
      if(res.code==200){
          this.jurisdictions=false
            this.$message({
              type: "success",
              message: "分配成功",
              })
              this.jurisdiction=[]
              this.getList()
       }else{
          $message.error(res.msg)
       
      }
  },
       //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .top-btn {
    margin: 15px 0;
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
</style>